<template>
  <FloatingDialog
    :model-value="!!uiStore.confirmDialog"
    :title="uiStore.confirmDialog?.title || 'Confirm'"
    max-width="420"
    @update:model-value="onClose"
  >
    <p class="text-body-1 m-0">{{ uiStore.confirmDialog?.message }}</p>

    <template #actions>
      <v-btn variant="text" @click="onClose(false)">Cancel</v-btn>
      <v-btn :color="uiStore.confirmDialog?.confirmColor || 'error'" @click="onConfirm">{{ uiStore.confirmDialog?.confirmText || 'Delete' }}</v-btn>
    </template>
  </FloatingDialog>
</template>

<script setup>
import { useUiStore } from '../../store/ui';
import FloatingDialog from './FloatingDialog.vue';

const uiStore = useUiStore();

function onClose(val) {
  if (!val) uiStore.closeConfirm();
}

async function onConfirm() {
  const action = uiStore.confirmDialog?.onConfirm;
  uiStore.closeConfirm();
  if (action) await action();
}
</script>
